angular.module("ainapp")
    .controller("ReorderTableController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
        function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Reorder Table";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.Init = function () {

                $scope.load = false;

                $scope.ViewVal = 0;
                $scope.ViewValType = 'Material Request';

                $scope.CostSetting = {
                    VoucherName: "Material Request",
                }


                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                loadData("Material Request");
                getTableReorderByType("Material Request");
            }
            $scope.Init();


            $scope.switchTab = function (tab, type) {
                $scope.ViewVal = tab;
                $scope.ViewValType = type;

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                loadData(type);
                getTableReorderByType(type);
            }

            function loadData(type) {
                $scope.columnListArray = [];
                $scope.CostCenters = [];
                $scope.Vdesign = {};
                MainService.VoucherDesignsbyType(type).then(function (response) {
                    if (response.data != null) {
                        $scope.Vdesign = response.data;
                        MainService.CostCentersInVoucher(type).then(function (response2) {
                            $scope.CostCenters = response2.data;

                            $scope.VoucherSet = {};
                            MainService.VoucherAccountsbyType(type).then(function (response3) {
                                if (response3.data != null) {
                                    $scope.VoucherSet = response3.data;
                                    generateColumnListArray()
                                }
                            })


                        });
                    } else {
                        $scope.Vdesign = {};
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })
            }

            function generateColumnListArray() {
                // console.log("$scope.LanguageData", $scope.LanguageData);
                // console.log("$scope.CostCenters", $scope.CostCenters);
                var columns = [
                    {
                        key: "#",
                        label: "#",
                        condition: true
                    },
                    {
                        key: "product_code",
                        label: $scope.LanguageData.Productcode,
                        condition: $scope.Vdesign.IsProCode
                    },
                    {
                        key: "product_name",
                        label: $scope.LanguageData.ProductName,
                        condition: true
                    },

                    {
                        key: "supplier_name",
                        label: "Supplier",
                        condition: $scope.ViewValType == "Individual Purchase Invoice" ? true : false
                    },
                    {
                        key: "supplier_mob",
                        label: "Supplier Mob",
                        condition: $scope.ViewValType == "Individual Purchase Invoice" && !$scope.Vdesign.HideCustomerMob ? true : false
                    },
                    {
                        key: "supplier_code",
                        label: "Supplier Code",
                        condition: $scope.ViewValType == "Individual Purchase Invoice" && !$scope.Vdesign.HideCustomerMob ? true : false
                    },
                    {
                        key: "debit_account",
                        label: "Debit Account",
                        condition: $scope.ViewValType == "Individual Purchase Invoice" ? true : false
                    },


                    {
                        key: "credit_account",
                        label: "Credit Account",
                        condition: $scope.ViewValType == "Individual Sales Invoice" ? true : false
                    }
                ];

                for (var i = 0; i < $scope.CostCenters.length; i++) {
                    var cost = $scope.CostCenters[i];
                    if (cost.Section === 'Body' && cost.IsMoveToFirst) {
                        columns.push({
                            key: "cost_center" + cost.CostCenter.Id,
                            label: cost.CostCenter.Name,
                            condition: true,
                            isMandatory: cost.IsMandatory
                        });
                    }
                }

                columns.push({
                        key: "description",
                        label: $scope.LanguageData.Description,
                        condition: $scope.Vdesign.IsDDescription
                    }, {
                        key: "master6",
                        label: $scope.CompanyProfile.Master6Name,
                        condition: $scope.Vdesign.IsMaster6
                    }, {
                        key: "brand",
                        label: "Brand",
                        condition: $scope.Vdesign.IsBrand
                    }, {
                        key: "country",
                        label: "Country",
                        condition: $scope.Vdesign.IsCountry
                    }, {
                        key: "year_ref",
                        label: $scope.Vdesign.YrRefLabel,
                        condition: $scope.Vdesign.IsYrRef
                    }, {
                        key: "manufacturer",
                        label: $scope.Vdesign.ManufLabel,
                        condition: $scope.Vdesign.IsManuf
                    }, {
                        key: "stock",
                        label: $scope.Vdesign.StockLabel,
                        condition: $scope.Vdesign.IsStock
                    }, {
                        key: "dfield1",
                        label: $scope.Vdesign.DField1,
                        condition: $scope.Vdesign.IsDField1
                    }, {
                        key: "dfield2",
                        label: $scope.Vdesign.DField2,
                        condition: $scope.Vdesign.IsDField2
                    }, {
                        key: "dfield3",
                        label: $scope.Vdesign.DField3,
                        condition: $scope.Vdesign.IsDField3
                    }, {
                        key: "dfield4",
                        label: $scope.Vdesign.DField4,
                        condition: $scope.Vdesign.IsDField4
                    }, {
                        key: "dfield5",
                        label: $scope.Vdesign.DField5,
                        condition: $scope.Vdesign.IsDField5
                    }, {
                        key: "unit",
                        label: $scope.LanguageData.Unit,
                        condition: $scope.Vdesign.IsDUnit
                    }, {
                        key: "vat",
                        label: $scope.LanguageData.VAT,
                        condition: $scope.Vdesign.IsDVat
                    }, {
                        key: "vat_type",
                        label: $scope.LanguageData.VATType,
                        condition: $scope.Vdesign.IsDVatType
                    }, {
                        key: "act_qty",
                        label: "Act Type",
                        condition: $scope.Vdesign.IsDActQty
                    }, {
                        key: "link_per",
                        label: "Link Per",
                        condition: $scope.Vdesign.IsDLinkPer
                    }, {
                        key: "quantity",
                        label: $scope.LanguageData.Quantity,
                        condition: $scope.Vdesign.IsDQuantity
                    }, {
                        key: "unit_price",
                        label: $scope.LanguageData.UnitPrice,
                        condition: $scope.Vdesign.IsDUnitPrice
                    }, {
                        key: "foc_qty",
                        label: $scope.LanguageData.FOCQty,
                        condition: $scope.Vdesign.IsDFocQuantity
                    }, {
                        key: "balance",
                        label: "Balance",
                        condition: $scope.Vdesign.IsBalanceQty
                    }, {
                        key: "net_weight",
                        label: $scope.LanguageData.NetWeight,
                        condition: $scope.Vdesign.IsDNetWeight
                    }, {
                        key: "gross_weight",
                        label: $scope.LanguageData.GrossWeight,
                        condition: $scope.Vdesign.IsDGrossWeight
                    }, {
                        key: "total_net_weight",
                        label: $scope.LanguageData.TNetWeight,
                        condition: $scope.Vdesign.IsDTotalNetWeight
                    }, {
                        key: "total_gross_weight",
                        label: $scope.LanguageData.TGrossWeight,
                        condition: $scope.Vdesign.IsDTotalGrossWeight
                    }, {
                        key: "cost",
                        label: $scope.LanguageData.Cost,
                        condition: $scope.Vdesign.IsDCost
                    }, {
                        key: "tcost",
                        label: $scope.Vdesign.TCostLabel,
                        condition: $scope.Vdesign.IsTCost
                    }, {
                        key: "qcost",
                        label: $scope.Vdesign.QCostLabel,
                        condition: $scope.Vdesign.IsQCost
                    }, {
                        key: "bonus",
                        label: $scope.Vdesign.BonusLabel,
                        condition: $scope.Vdesign.IsBonus
                    }, {
                        key: "gross",
                        label: $scope.LanguageData.Gross,
                        condition: $scope.Vdesign.IsDGross
                    }, {
                        key: "discount_value",
                        label: $scope.LanguageData.DiscValue,
                        condition: $scope.Vdesign.IsDiscountValue
                    }, {
                        key: "discount_type",
                        label: $scope.LanguageData.DiscType,
                        condition: $scope.Vdesign.IsDiscountType
                    }, {
                        key: "discount",
                        label: $scope.LanguageData.Discount,
                        condition: $scope.Vdesign.IsDDiscount
                    },


                    {
                        key: "clearing_Charges",
                        label: $scope.LanguageData.ClearingCharges,
                        condition: $scope.Vdesign.IsClearingCharges
                    }, {
                        key: "duty_charges",
                        label: $scope.LanguageData.CustomDuty,
                        condition: $scope.Vdesign.IsDutyCharges
                    }, {
                        key: "delivery_charges",
                        label: $scope.LanguageData.DeliveryCharges,
                        condition: $scope.Vdesign.IsDeliveryCharges
                    },


                    {
                        key: "other_charges",
                        label: $scope.LanguageData.OtherCharges,
                        condition: $scope.Vdesign.IsOtherCharges
                    }, {
                        key: "assessable_value",
                        label: "Assessable Value",
                        condition: $scope.VoucherSet.IsReverseVAT
                    }, {
                        key: "vat1_per",
                        label: "Vat 1 %",
                        condition: $scope.Vdesign.IsVat1Per
                    }, {
                        key: "vat1_value",
                        label: "Vat 1 Value",
                        condition: $scope.Vdesign.IsVat1Value
                    }, {
                        key: "vat2_per",
                        label: "Vat 2 %",
                        condition: $scope.Vdesign.IsVat2Per
                    }, {
                        key: "vat2_value",
                        label: "Vat 2 Value",
                        condition: $scope.Vdesign.IsVat2Value
                    }, {
                        key: "vat3_per",
                        label: "Vat 3 %",
                        condition: $scope.Vdesign.IsVat3Per
                    }, {
                        key: "vat3_value",
                        label: "Vat 3 Value",
                        condition: $scope.Vdesign.IsVat3Value
                    }, {
                        key: "vat4_per",
                        label: "Vat 4 %",
                        condition: $scope.Vdesign.IsVat4Per
                    }, {
                        key: "vat4_value",
                        label: "Vat 4 Value",
                        condition: $scope.Vdesign.IsVat4Value
                    }, {
                        key: "vat5_per",
                        label: "Vat 5 %",
                        condition: $scope.Vdesign.IsVat5Per
                    }, {
                        key: "vat5_value",
                        label: "Vat 5 Value",
                        condition: $scope.Vdesign.IsVat5Value
                    }, {
                        key: "taxable_amt",
                        label: "Taxable",
                        condition: $scope.Vdesign.IsDTaxable
                    }, {
                        key: "total_vat",
                        label: "Total Vat",
                        condition: $scope.Vdesign.IsDTotalVat
                    }, {
                        key: "round_vat",
                        label: $scope.LanguageData.RoundVat,
                        condition: $scope.Vdesign.IsDRoundVat
                    },


                    {
                        key: "frieght_charges",
                        label: $scope.LanguageData.FreightCharges,
                        condition: $scope.Vdesign.IsFrieghtCharges
                    }, {
                        key: "packing_charges",
                        label: $scope.LanguageData.PackingCharges,
                        condition: $scope.Vdesign.IsPackingCharges
                    },


                    {
                        key: "extra_charges",
                        label: $scope.LanguageData.ExtraCharges,
                        condition: $scope.Vdesign.IsExtraCharges
                    },
                    //                             {
                    //                        key: "field21",
                    //                        label: "Field 21",
                    //                        condition: $scope.Vdesign.IsDField21
                    //                    }, {
                    //                        key: "field22",
                    //                        label: "Field 22",
                    //                        condition: $scope.Vdesign.IsDField22
                    //                    }, {
                    //                        key: "field23",
                    //                        label: "Field 23",
                    //                        condition: $scope.Vdesign.IsDField23
                    //                    }, {
                    //                        key: "field24",
                    //                        label: "Field 24",
                    //                        condition: $scope.Vdesign.IsDField24
                    //                    }, {
                    //                        key: "field25",
                    //                        label: "Field 25",
                    //                        condition: $scope.Vdesign.IsDField25
                    //                    }, {
                    //                        key: "field26",
                    //                        label: $scope.Vdesign.DField26,
                    //                        condition: $scope.Vdesign.IsDField26
                    //                    }, {
                    //                        key: "field27",
                    //                        label: $scope.Vdesign.DField27,
                    //                        condition: $scope.Vdesign.IsDField27
                    //                    }, {
                    //                        key: "field28",
                    //                        label: $scope.Vdesign.DField28,
                    //                        condition: $scope.Vdesign.IsDField28
                    //                    }, {
                    //                        key: "field29",
                    //                        label: $scope.Vdesign.DField29,
                    //                        condition: $scope.Vdesign.IsDField29
                    //                    }, {
                    //                        key: "field30",
                    //                        label: $scope.Vdesign.DField30,
                    //                        condition: $scope.Vdesign.IsDField30
                    //                    },
                    {
                        key: "total",
                        label: $scope.LanguageData.Total,
                        condition: $scope.Vdesign.IsDTotal
                    }, {
                        key: "warehouse",
                        label: $scope.LanguageData.WareHouse,
                        condition: $scope.Vdesign.IsWareHouse
                    }, {
                    }, {
                        key: "warehouse2",
                        label: "warehouse2",
                        condition: $scope.Vdesign.IsWareHouse2
                    }, {
                    }, {
                        key: "warehouse_stock",
                        label: "Warehouse Stock",
                        condition: $scope.Vdesign.IsWareHouse
                    }, {
                        key: "dfield6",
                        label: $scope.Vdesign.DField6,
                        condition: $scope.Vdesign.IsDField6
                    }, {
                        key: "dfield7",
                        label: $scope.Vdesign.DField7,
                        condition: $scope.Vdesign.IsDField7
                    }, {
                        key: "dfield8",
                        label: $scope.Vdesign.DField8,
                        condition: $scope.Vdesign.IsDField8
                    }, {
                        key: "dfield9",
                        label: $scope.Vdesign.DField9,
                        condition: $scope.Vdesign.IsDField9
                    }, {
                        key: "dfield10",
                        label: $scope.Vdesign.DField10,
                        condition: $scope.Vdesign.IsDField10
                    }, {
                        key: "dfield11",
                        label: $scope.Vdesign.DField11,
                        condition: $scope.Vdesign.IsDField11
                    }, {
                        key: "dfield12",
                        label: $scope.Vdesign.DField12,
                        condition: $scope.Vdesign.IsDField12
                    }, {
                        key: "dfield13",
                        label: $scope.Vdesign.DField13,
                        condition: $scope.Vdesign.IsDField13
                    }, {
                        key: "dfield14",
                        label: $scope.Vdesign.DField14,
                        condition: $scope.Vdesign.IsDField14
                    }, {
                        key: "dfield15",
                        label: $scope.Vdesign.DField15,
                        condition: $scope.Vdesign.IsDField15
                    }, {
                        key: "dfield16",
                        label: $scope.Vdesign.DField16,
                        condition: $scope.Vdesign.IsDField16
                    }, {
                        key: "dfield17",
                        label: $scope.Vdesign.DField17,
                        condition: $scope.Vdesign.IsDField17
                    }, {
                        key: "dfield18",
                        label: $scope.Vdesign.DField18,
                        condition: $scope.Vdesign.IsDField18
                    }, {
                        key: "dfield19",
                        label: $scope.Vdesign.DField19,
                        condition: $scope.Vdesign.IsDField19
                    }, {
                        key: "dfield20",
                        label: $scope.Vdesign.DField20,
                        condition: $scope.Vdesign.IsDField20
                    }, {
                        key: "field21",
                        label: $scope.Vdesign.DField21,
                        condition: $scope.Vdesign.IsDField21
                    }, {
                        key: "field22",
                        label: $scope.Vdesign.DField22,
                        condition: $scope.Vdesign.IsDField22
                    }, {
                        key: "field23",
                        label: $scope.Vdesign.DField23,
                        condition: $scope.Vdesign.IsDField23
                    }, {
                        key: "field24",
                        label: $scope.Vdesign.DField24,
                        condition: $scope.Vdesign.IsDField24
                    }, {
                        key: "field25",
                        label: $scope.Vdesign.DField25,
                        condition: $scope.Vdesign.IsDField25
                    }, {
                        key: "field26",
                        label: $scope.Vdesign.DField26,
                        condition: $scope.Vdesign.IsDField26
                    }, {
                        key: "field27",
                        label: $scope.Vdesign.DField27,
                        condition: $scope.Vdesign.IsDField27
                    }, {
                        key: "field28",
                        label: $scope.Vdesign.DField28,
                        condition: $scope.Vdesign.IsDField28
                    }, {
                        key: "field29",
                        label: $scope.Vdesign.DField29,
                        condition: $scope.Vdesign.IsDField29
                    }, {
                        key: "field30",
                        label: $scope.Vdesign.DField30,
                        condition: $scope.Vdesign.IsDField30
                    }, {
                        key: "master7",
                        label: $scope.CompanyProfile.Master7Name,
                        condition: $scope.Vdesign.IsMaster7
                    }, {
                        key: "master8",
                        label: $scope.CompanyProfile.Master8Name,
                        condition: $scope.Vdesign.IsMaster8
                    }, {
                        key: "cogs_account",
                        label: "COGS Account",
                        condition: $scope.ViewValType == "Individual Sales Invoice" ? true : false
                    }, {
                        key: "inventory_account",
                        label: "Inventory Account",
                        condition: $scope.ViewValType == "Individual Sales Invoice" ? true : false
                    }
                );

                for (var i = 0; i < $scope.CostCenters.length; i++) {
                    var cost = $scope.CostCenters[i];
                    if (cost.Section === 'Body' && !cost.IsMoveToFirst) {
                        columns.push({
                            key: "cost_center" + cost.CostCenter.Id,
                            label: cost.CostCenter.Name,
                            condition: true,
                            isMandatory: cost.IsMandatory
                        });
                    }
                }
                $scope.columnListArray = [];
                for (var i = 0; i < columns.length; i++) {
                    var column = columns[i];
                    if (column.condition) {
                        $scope.columnListArray.push({
                            label: column.label,
                            key: column.key
                        });
                    }
                }

                // Check saved order and apply
                if ($scope.columnArray && $scope.columnArray.length > 0) {
                    $scope.columnListArray = sortByOrder($scope.columnListArray, $scope.columnArray);
                }
            }

            function sortByOrder(list, order) {
                return list.sort(function (a, b) {
                    return order.indexOf(a.key) - order.indexOf(b.key)
                });
            }

            function getTableReorderByType(type) {
                $scope.TableReorder = {
                    ColumnArray: ""
                };
                $scope.columnArray = [];
                MainService.TableReorderByType(type).then(function (response) {
                    if (response.data != null && response.data != "") {
                        $scope.TableReorder = response.data;
                        $scope.columnArray = $scope.TableReorder.ColumnArray ? JSON.parse($scope.TableReorder.ColumnArray) : [];
                    }

                    // console.log("getTableReorderByType", $scope.columnArray)
                }, function (err) {
                    toastr.error("Network Error");
                })

            }

            $scope.saveCostSettings = function () {

                $scope.TableReorder.VoucherName = $scope.ViewValType;
                $scope.TableReorder.ColumnArray = "";

                var columnsOrderToSave = [];
                for (var i = 0; i < this.columnListArray.length; i++) {
                    var column = this.columnListArray[i];
                    columnsOrderToSave.push(column.key);
                }
                $scope.TableReorder.ColumnArray = JSON.stringify(columnsOrderToSave);

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.AddTableReorder($scope.TableReorder).then(function (response) {
                    if (response.data) {
                        toastr.success("Success");
                        $scope.switchTab($scope.ViewVal, $scope.ViewValType);
                        $scope.switchTab($scope.ViewVal, $scope.ViewValType);
                    } else {
                        toastr.error("Network Error");
                    }
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })
            }
        }]);
